'use client';
import {
  LAZY_SECTION_IN_VIEW_OPTIONS,
  useInView,
} from '@/shared/hooks/useInView';
import { DynamicRecordWins } from '@/widgets/record-wins';
import { RecordWinWrapper } from './styles';

export const RecordWinSection = () => {
  const [ref, isVisible] = useInView(LAZY_SECTION_IN_VIEW_OPTIONS);

  return (
    <RecordWinWrapper ref={ref} $collapse={isVisible}>
      {isVisible && <DynamicRecordWins />}
    </RecordWinWrapper>
  );
};
